import { UserRolesEnum } from '../../interfaces/user.interface';

export interface GoodModeState {
  type: UserRolesEnum | null;
}

export const initialGoodModeState: GoodModeState = {
  type: null,
};
